export const Field = ({ id, label, error, className = "", ...input }) => (
  <div className={className}>
    <label className="field-label" htmlFor={id}>{label}</label>
    <input id={id} className={`text-input${error ? " invalid" : ""}`} data-testid={`input-${id}`} {...input} />
    {error && <div className="field-error" data-testid={`error-${id}`}>{error}</div>}
  </div>
);

export const formatPhone = (v) => {
  const d = v.replace(/\D/g, "").slice(0, 10);
  if (d.length <= 3) return d.length ? `(${d}` : "";
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
};

const RULES = {
  first_name: [(v) => v.trim().length > 0, "Please enter your first name."],
  last_name: [(v) => v.trim().length > 0, "Please enter your last name."],
  email: [(v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim()), "Please enter a valid email address."],
  phone: [(v) => v.replace(/\D/g, "").length >= 10, "Please enter your phone number."],
  address: [(v) => v.trim().length > 0, "Please enter your street address."],
  city: [(v) => v.trim().length > 0, "Please enter your city."],
  state: [(v) => /^[A-Za-z]{2}$/.test(v.trim()), "Please enter your 2-letter state."],
};

export const validate = (name, value) => {
  const rule = RULES[name];
  return rule && !rule[0](value) ? rule[1] : "";
};

export const MEETS_ERROR = "Please answer this question before submitting.";
export const MISSING_ERROR = "Please tell us what you are missing from the criteria.";
export const CONSENT_ERROR = "Please check this box to agree to receive SMS messages before submitting.";

export const validateAll = (values, meets, missing, consent) => {
  const errs = Object.keys(RULES).reduce((acc, k) => {
    const e = validate(k, values[k]);
    return e ? { ...acc, [k]: e } : acc;
  }, {});
  if (!meets) errs.meets = MEETS_ERROR;
  if (meets === "no" && !missing.trim()) errs.missing = MISSING_ERROR;
  if (!consent) errs.sms_consent = CONSENT_ERROR;
  return errs;
};
